import { useMemo } from "react";

import { buildSurveyAnswerContentItems } from "../utils/surveyAnswerDisplay";
import type { SurveyAnswerContentProps } from "../types";

const SurveyAnswerContent = ({
  question,
  answers,
}: SurveyAnswerContentProps) => {
  const contentItems = useMemo(
    () => buildSurveyAnswerContentItems(question, answers),
    [question, answers],
  );

  if (contentItems.length === 0) {
    return null;
  }

  return (
    <div className="overview-answer-content-items flex flex-col gap-400">
      {contentItems}
    </div>
  );
};

export default SurveyAnswerContent;
